import { useLayoutEffect, useRef, useState } from "react";
import { Linkify } from "@/components/messages/shared";

export function ExpandableText({ text, lines = 6, testid, className = "" }) {
  const ref = useRef(null);
  const [clamped, setClamped] = useState(false);
  const [open, setOpen] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || open) return;
    setClamped(el.scrollHeight > el.clientHeight + 2);
  }, [text, lines, open]);

  if (!text) return null;
  const style = open ? undefined : { display: "-webkit-box", WebkitLineClamp: lines, WebkitBoxOrient: "vertical", overflow: "hidden" };
  return (
    <div className={className}>
      <p ref={ref} style={style} className="text-sm whitespace-pre-wrap break-words leading-relaxed" data-testid={testid} data-expanded={open}><Linkify text={text} /></p>
      {(clamped || open) && (
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`${testid}-toggle`}
                className="mt-1 text-xs font-semibold text-zinc-600 hover:text-black min-h-[32px] px-1 -ml-1 rounded-lg active:bg-zinc-100">
          {open ? "Ver menos" : "Ver mais"}
        </button>
      )}
    </div>
  );
}
